import type { StudentPortfolioTaskShallowResource } from "api/generated";
import type { PortfolioShallowStudentTask } from "portfolio/types/portfolioShallowTask.types";

export const portfolioShallowStudentTaskFromDto = (
  data: StudentPortfolioTaskShallowResource,
): PortfolioShallowStudentTask => ({
  id: data.id,
  title: data.title,
  status: data.status,
  description: data.description,
  deadline: new Date(data.deadline),
  banner: data.banner,
  isRequired: data.is_required,
  allowTaskRatings: data.allow_task_ratings,
  createdAt: data.created_at ? new Date(data.created_at) : null,
  tags: data.tags,
});
